<template>

    <nav class="filter-nav">
        
        <div class="custom-select form-group">
            <select name="order" id="filter-by" @change="orderChange">
                <option value="">Vybrať</option>
                <option value="new-desc">Najnovšie</option>
                <option value="price-asc">Najlacnejšie</option>
                <option value="price-desc">Najdrahšie</option>
            </select>
        </div>

        <div class="layout-switch">
            <span class="js-layout-switch active" data-layout="layout-grid">
                <i class="fas fa-th"></i>
            </span>
            <span class="js-layout-switch" data-layout="layout-list">
                <i class="fas fa-th-list"></i>
            </span>
        </div>
    </nav>
    
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'

import emitter from '../../utils/emitter'

export default defineComponent({

    props: {
        productsCount: {
            required: false,
            type: Number
        }
    },

    emits: ['onOrderChanged'],

    setup(props, { emit }) {

        const sort = ref('')

        onMounted( () => {
            emitter.on('setValuesFromParameters', ( {order} ) => sort.value = order)

            setTimeout( () => setSelectedOption(), 50)
        })

        function orderChange() { emit('onOrderChanged') }

        function setSelectedOption() {
            Array.from(document.querySelector('#filter-by').options).forEach( (option) => {
                if ( option.value === sort.value ) option.setAttribute('selected', true);
            })
        }

        return {
            orderChange,
            setSelectedOption
        }
    }
})
</script>
